<template>
  <b-input v-model.number="perPage"
           :style="perPageFieldWidth"
           class="pa-1"
           min="1"
           type="number"
           v-text="perPage"/>
</template>
<script>
  export default {
    name: 'BasePerPageInput',
    props: {
      value: {
        type: Number,
        required: true,
      },
    },
    data() {
      return { perPage: this.value };
    },
    computed: {
      perPageFieldWidth() {
        const visualOffset = 5;
        return `width: ${String(this.perPage).length + visualOffset}ch;`;
      },
    },
    watch: {
      perPage: {
        handler() {
          if (!this.perPage) {
            this.perPage = this.value;
          }
          this.$emit('input', this.perPage);
        },
      },
    },
  };
</script>
